import { NavLink } from 'react-router-dom';

import { UikitMenuSidebar } from '../../components/UikitMenuSidebar';
import { UikitMenu } from '../../components/UikitMenu';
import { routes } from '../../routes';

const base = `/${routes.START}`;
const title = 'Getting started';

const navLinkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

export const getStartMenuItems = () => {
    const menu = [
        {
            group: 'Welcome',
            navItems: [
                {
                    key: 'Intro',
                    meta: 'intro',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/intro`}>
                            Intro
                        </NavLink>
                    ),
                },
                {
                    key: 'How to',
                    meta: 'howto installation',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/howto`}>
                            Installation
                        </NavLink>
                    ),
                },
                {
                    key: 'Changelog',
                    meta: 'changelog',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/changelog`}>
                            Changelog
                        </NavLink>
                    ),
                },
            ],
        },
        {
            group: 'Guidelines',
            navItems: [
                {
                    key: 'Responsiveness',
                    meta: 'responsiveness platforms breakpoints col grid flex',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/responsiveness`}>
                            Responsiveness
                        </NavLink>
                    ),
                },
                {
                    key: 'Good to know',
                    meta: 'goodtoknow',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/goodtoknow`}>
                            Good to know
                        </NavLink>
                    ),
                },
                {
                    key: 'State in URL',
                    meta: 'state-in-url deep link url',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/state-in-url`}>
                            State in URL
                        </NavLink>
                    ),
                },
                {
                    key: 'Color combinations',
                    meta: 'color-combinations',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/color-combinations`}>
                            Color combinations
                        </NavLink>
                    ),
                },
                {
                    key: 'Custom CSS',
                    meta: 'custom-css',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/custom-css`}>
                            Custom CSS
                        </NavLink>
                    ),
                },
                {
                    key: 'Custom icons',
                    meta: 'custom-rioglyph',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/custom-rioglyph`}>
                            Custom icons
                        </NavLink>
                    ),
                },
                {
                    key: 'iframe',
                    meta: 'iframe',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/iframe`}>
                            Iframes
                        </NavLink>
                    ),
                },
                {
                    key: 'Loading',
                    meta: 'spinner',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/spinner`}>
                            Loading
                        </NavLink>
                    ),
                },
                {
                    key: 'Email',
                    meta: 'email',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/email`}>
                            HTML emails
                        </NavLink>
                    ),
                },
                {
                    key: 'Print CSS',
                    meta: 'print-css',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/print-css`}>
                            Print CSS
                        </NavLink>
                    ),
                },
                {
                    key: 'Obfuscate pii sensible',
                    meta: 'obfuscate-data',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/obfuscate-data`}>
                            Obfuscate data
                        </NavLink>
                    ),
                },
                {
                    key: 'Supported Browsers',
                    meta: 'supported-browsers',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/supported-browsers`}>
                            Supported Browsers
                        </NavLink>
                    ),
                },
                {
                    key: 'Formatting guide',
                    meta: 'formatting date number dateformat datetime time format',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/formatting`}>
                            Formatting guide
                        </NavLink>
                    ),
                },
                {
                    key: 'Writing style guide',
                    meta: 'writing',
                    item: (
                        <NavLink className={navLinkClass} to={`${base}/guidelines/writing`}>
                            Writing style guide
                        </NavLink>
                    ),
                },
            ],
        },
        {
            group: 'Demo service',
            navItems: [
                {
                    key: 'Start',
                    meta: 'start',
                    item: (
                        <NavLink className={navLinkClass} to='/demoService/start'>
                            Start
                        </NavLink>
                    ),
                },
                {
                    key: 'Table',
                    meta: 'table',
                    item: (
                        <NavLink className={navLinkClass} to='/demoService/table'>
                            Table
                        </NavLink>
                    ),
                },
            ],
        },
    ];

    return menu.map(item => ({ ...item, badge: title }));
};

export const StartMenu = () => (
    <UikitMenuSidebar title={title}>
        <UikitMenu />
    </UikitMenuSidebar>
);
